module.exports = "<div class=\"dateSeparator_border\"></div><div class=\"dateSeparator_text\">{{date}}</div><div class=\"clear\"></div>";